import React, { useEffect, useState } from "react"; // Ensure useEffect is imported
import { Col, Row, Form, message, Typography } from "antd";
import { CustomButton, CustomInput } from "../../components";
import { useSpin } from "../../components/SpinContext";
import { useNavigate } from "react-router-dom";
import { setAuthState } from "../../reudx-toolkit/slice/authSlice";
import { Login } from "../../api's/auth";
import { useToken } from "../../common/helper";
import { fetchTeamsDDL } from "../../reudx-toolkit/slice/teamsSlice";
import { persistor } from "../../reudx-toolkit/store";
//import { fetchAllCouriers } from "../../reudx-toolkit/slice/onboardingSlice";
import { useDispatch } from "react-redux";
import { fetchMenu } from "../../reudx-toolkit/slice/menuSlice";
import { useWebSocket } from "../../context/WebSocketContext";
//import { fetchAllLocations } from "../../reudx-toolkit/slice/LocationSlice";
//import { fetchAllProductTypes } from "../../reudx-toolkit/slice/ProductTypeSlice";
//import { fetchAllProducts } from "../../reudx-toolkit/slice/ProductSlice";
const { Text } = Typography;
const LoginForm = () => {
  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);
  const navigate = useNavigate();
  const { showSpin, hideSpin } = useSpin();
   const { userID, setUserId, removeToken, decodedUserToken, saveLoginUser } = useToken();
        const { webSocketService, setSelectedUserID } = useWebSocket();
  const dispatch = useDispatch();
  const [token, setToken] = useState();

  useEffect(() => {
    const isAuthenticated = localStorage.getItem("@token");
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [navigate]);

  // useEffect(() => {
  //   if (dispatch && token) {
  //     dispatch(fetchAllCouriers(token))
  //     dispatch(fetchAllLocations(token))
  //     dispatch(fetchAllProductTypes(token))
  //     dispatch(fetchAllProducts(token))
  //   }
  // }, [dispatch,token]);

  const onFinish = async (values) => {
    if (values && Object.keys(values).length > 0) {
      setIsFormValid(true);
      showSpin();
      try {
        const res = await Login(values);
        console.log('res',res)
        if (res?.data?.is_success) {
          
          await persistor.flush();
          await persistor.purge();
          localStorage.removeItem("persist:root");
          localStorage.setItem('@refreshToken', res?.data?.refresh);
          await saveLoginUser(res?.data?.access);
          dispatch(setAuthState(true));
          dispatch(fetchTeamsDDL(res?.data?.access));

          let isOnboarded = false;
          let decodedToken = decodedUserToken();
          let user = decodedToken?.role?.toLowerCase() === "admin";

          if (decodedToken) {
            isOnboarded = decodedToken?.is_onboarded === true;
          }
          
          const menuResult = await dispatch(fetchMenu(res?.data?.access)).unwrap();
          
console.log('menu result : ' , menuResult)

          if (menuResult?.length === 0) {
            message.error("You don't have permission to access this application. Please contact your administrator.");
            removeToken();
            setUserId(null);
            setSelectedUserID(null);
            webSocketService.disconnect();
            persistor.flush().then(() => {
                    persistor.purge();
                    localStorage.clear();
                  });
            return;
          }

          if (!isOnboarded && user) {
            navigate("/onboarding");
            return;
          }
          
          if (menuResult && Array.isArray(menuResult) && menuResult.length > 0) {
            // const firstRoute = menuResult[1];
            const firstRoute =  menuResult.find(item => item.route && typeof item.route === "string");
            if (firstRoute) {
              navigate(`/${firstRoute.route}`);
            }
          }
          
          
          
          // if (isOnboarded && user) {
          //   navigate("/shipment");
          // } else if (!isOnboarded && user) {
          //   navigate("/onboarding");
          // } else {
          //   navigate("/shipment");
          // }



        } else {
          message.error(res?.data?.data?.message);
        }
      } catch (error) {
        console.error("Login Error:", error);
        if (error === "NO_MENU_ITEMS") {
          message.error("You don't have permission to access this application. Please contact your administrator.");
          removeToken();
          setUserId(null);
          setSelectedUserID(null);
          webSocketService.disconnect();
        }
      } finally {
        hideSpin();
        setIsFormValid(false);
      }
    }
  };

  const handleClick = () => {
    navigate("/signup");
  };

  return (
    <div className="login-form">
      <Form
        layout="vertical"
        form={form}
        name="validateOnly"
        onFinish={onFinish}
      >
        <Row gutter={[16, 24]}>
          <Col span={24}>
            <Form.Item
              className="custom-input"
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please enter your email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <CustomInput
                placeholder="Enter email"
                height="36px"
                border="0px"
                bgColor="#F3F3F3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                lineHeight="38px"
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              className="custom-input"
              label="Password"
              name="password"
              rules={[
                { required: true, message: "Please enter your password" },
                { type: "password", message: "Please enter a valid password" },
                {
                  type: "string",
                  min: 6,
                  message: "Password must be at least 6 characters long.",
                },
                {
                  type: "string",
                  max: 20,
                  message: "Password cannot exceed 20 characters.",
                },
              ]}
            >
              <CustomInput
                placeholder="Enter password"
                height="36px"
                border="0px"
                bgColor="#F3F3F3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                lineHeight="38px"
                type="password"
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <CustomButton
              text="Login"
              block="block"
              height="36px"
              bgColor="#000"
              color="#fff"
              borderRadius="8px"
              fontSize={14}
              fontWeight={500}
              isFormValid={isFormValid}
              htmlType="submit"
            />
          </Col>
        </Row>
      </Form>

      <Row justify="center" align="middle" style={{ marginTop: "20px" }}>
        <Col>
          <p
            style={{
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              color: "#5E5E5E",
              marginBottom: '2px'
            }}
          >
            Don't have an account?{" "}
            <span 
              onClick={handleClick} 
              style={{ 
                cursor: "pointer", 
                textDecoration: 'underline',
                fontWeight: "500"
              }}>
              Sign up
            </span>
          </p>
        </Col>
      </Row>

      <Row justify="center" align="middle" style={{ marginTop: "0px" }}>
        <Col>
          <Text
            style={{
              cursor: "pointer",
              color: "#5E5E5E",
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "20px",
              textDecoration: 'underline'
            }}
            onClick={() => navigate("/forgot-password")}
          >
            Forgot Password?
          </Text>
        </Col>
      </Row>
    </div>
  );
};

export default LoginForm;
